import { IFluidCodeDetails } from '@fluidframework/core-interfaces';
import { IComponentRenderOptions } from '@fluidx/office-fluid-types';
import { HostConfig } from '@ms/office-web-host';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getAppLogger } from './appLogger';
import { AppHostContext } from './hostContext/AppHostContext';
import { FluidOwaSource } from 'owa-fluid-validations';
import { CH2_APP_NAME } from '../constants';
import { assertNever } from 'owa-assert';

// Don't use cached items from more than 3 days ago
const maxItemCacheAge = 3 * 24 * 60 * 60 * 1000;

export function generateHostConfig(
    hostContext: AppHostContext,
    owaSource: FluidOwaSource,
    componentRenderOptions?: IComponentRenderOptions,
    codeDetails?: IFluidCodeDetails
): HostConfig {
    const loaderOptions = getLoaderOptionsFromSource(owaSource);
    return {
        logger: getAppLogger(hostContext),
        componentRenderOptions: componentRenderOptions,
        codeDetails: codeDetails,
        loaderOptions: loaderOptions ?? undefined,
        persistentCacheConfig: {
            enabled: isFeatureEnabled('cmp-fluidSnapshot') ? true : false,
            maxCacheItemAge: maxItemCacheAge,
        },
    };
}

function getLoaderOptionsFromSource(source: FluidOwaSource) {
    switch (source) {
        case FluidOwaSource.CalendarReadingPane:
        case FluidOwaSource.CalendarCompose:
        case FluidOwaSource.MailCalendarCard:
            return {
                appName: CH2_APP_NAME,
            };
        case FluidOwaSource.MailCompose:
        case FluidOwaSource.MailReadingPane:
        case FluidOwaSource.AgendaEditor:
        case FluidOwaSource.Timestream:
        case FluidOwaSource.None:
            return null;
        default:
            return assertNever(source);
    }
}
